import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import mutationDocument from "./setDefaultPaymentMutation.graphql";
import type {
  GetCustomerPaymentInstrumentsRequestResultType,
  InputSetDefaultPaymentType,
  Mutations,
  MutationsSetDefaultPaymentArgs,
} from "@/core/api/graphql/types";

export async function setDefaultCreditCard(
  payload: InputSetDefaultPaymentType,
): Promise<GetCustomerPaymentInstrumentsRequestResultType> {
  const { userId } = globals;
  const { data } = await graphqlClient.mutate<
    Required<Pick<Mutations, "setDefaultPayment">>,
    MutationsSetDefaultPaymentArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: {
        userId,
        ...payload,
      },
    },
  });

  return data!.setDefaultPayment;
}
